export enum TeamTypeLifecycleStepTrigger {
	CurrentPeriodActive,
	CurrentPeriodEnded,
	DaysAfterPreviousStep
}